import { useEffect, useId, useRef, type ReactNode } from 'react';

/** Native modal focus containment, Escape, and focus restoration work inside the OS iframe too. */
export default function SheetDialog({ open, title, onClose, busy = false, children, wide = false }: {
  open: boolean; title: string; onClose: () => void; busy?: boolean; children: ReactNode; wide?: boolean;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
    return () => { if (dialog.open) dialog.close(); };
  }, [open]);
  return <dialog ref={ref} className={`sheet-dialog ${wide ? 'sheet-wide' : ''}`} aria-labelledby={titleId}
    onCancel={event => { event.preventDefault(); event.stopPropagation(); if (!busy) onClose(); }}
    onClick={event => { if (event.target === event.currentTarget && !busy) onClose(); }}>
    {open && <div className="sheet-inner">
      <div className="sheet-handle" aria-hidden="true" />
      <header className="sheet-heading"><h2 id={titleId} className="font-display text-2xl">{title}</h2>
        <button type="button" onClick={onClose} disabled={busy} autoFocus>Close</button></header>
      <div className="sheet-content">{children}</div>
    </div>}
  </dialog>;
}
